import { EndResult } from '@/components/ballot-results-pane/top'
import { FederalBallotSummary } from '@/domain/FederalBallotSummary'
import { pickMultiLocaleString } from '@/domain/multi-locale-string'
import { OverrideableBallotState } from '@/domain/overrideable-ballot-state'
import * as React from 'react'
import { css } from 'styled-components/macro'
import { useEnv } from '../../../lib'
import Gauge from '../../gauge'

const Root = 'div'

interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  state: OverrideableBallotState
  summary: FederalBallotSummary
}

function TileTop(props: Props) {
  const { intl } = useEnv()

  const { state, summary, ...rest } = props

  return (
    <Root {...rest} css={styles.root as any}>
      <div css={styles.name as any}>{pickMultiLocaleString(intl, summary.name, '<federal ballot name>')}</div>
      <div css={styles.label as any}>
        <EndResult overrideableBallotState={state} />
      </div>
      <Gauge ballotState={state.ballotState} summary={summary} outcome={state.outcome} />
    </Root>
  )
}

const styles = {
  root: css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    _background: #f8f7f4;
  `,
  name: css`
    font-family: var(--font-sans-serif);
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.3;
    margin-bottom: 1.4rem;
    @media screen and (min-width: 600px) and (max-width: 1024px) {
      margin-bottom: 1.2rem;
    }
    @media screen and (min-width: 1025px) {
      margin-bottom: 1.2rem;
    }
  `,
  label: css``,
}

export default TileTop
